module.exports = __webpack_public_path__ + "static/media/facet_icon.ea67f7bc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Kendra/images/facet_icon.svg
// module id = 3149
// module chunks = 0